import axios from 'axios';
import { useAuthStore } from '@/stores/auth.store';
import router from '@/router';

const API_URL = import.meta.env.VITE_API_URL;

// Création d'une instance axios avec la configuration de base
const axiosInstance = axios.create({
  baseURL: API_URL
});

// Intercepteur pour ajouter le token à chaque requête
axiosInstance.interceptors.request.use(config => {
  const user = JSON.parse(localStorage.getItem('user'));
  if (user?.token) {
    config.headers.Authorization = `Bearer ${user.token}`;
  }
  return config;
});

// Liste des routes publiques qui ne nécessitent pas de redirection en cas de 401
const publicRoutes = [
  '/public/',
  '/auth/register',
  '/auth/login',
  '/auth/forgot-password',
  '/auth/reset-password',
  '/memberarea/dashboard'
];

// Liste des routes qui nécessitent une authentification
const protectedRoutes = [
  '/memberarea/cart',
  '/memberarea/profile',
  '/memberarea/herd',
  '/memberarea/invoices'
];

// Intercepteur pour gérer les erreurs de réponse
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Vérifier si c'est une erreur 401 et que ce n'est pas déjà une tentative de refresh
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      // Vérifier si la requête concerne une route protégée
      const isProtectedRoute = protectedRoutes.some(route => 
        originalRequest.url.includes(route)
      );

      // Si c'est une route protégée, procéder à la déconnexion et redirection
      if (isProtectedRoute) {
        const authStore = useAuthStore();
        
        // Déconnexion et redirection vers login
        await authStore.logout();
        
        // Stocker l'URL actuelle pour la redirection après login
        authStore.returnUrl = router.currentRoute.value.fullPath;
        
        // Rediriger vers la page de login
        router.push('/login');
      }

      // Pour les routes publiques, on laisse simplement passer l'erreur
      return Promise.reject(error);
    }

    return Promise.reject(error);
  }
);

export default axiosInstance; 